import { MEMBERSHIP_MODELS, getSingleChoiceValue } from '@r-and-a-shared-ui/common-kontent-client';

export const restricted_content = (data: MEMBERSHIP_MODELS.RestrictedContent) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    text: elements?.text?.value,
    subtext: elements?.subtext?.value,
    access: getSingleChoiceValue(elements?.membership_based_access__select_access)
  };
};

export default restricted_content;
